import styled, { css, keyframes } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { Card, CardContent } from '@prisjakt/ui/card';
import { PrimaryButton } from '@prisjakt/ui/button/variants';
import ModalComponent from 'src/components/modal';

export const Wrapper = styled.div`
  background-color: ${p => p.theme.colors.maybeBlue100};
  padding: ${layout.measurements.spacing150} 0;
  display: flex;
  justify-content: center;

  ${media.smallOnly`
    padding: ${layout.measurements.spacing150};
    // Force wrapper to the edges of the screen
    margin-left: -${layout.measurements.spacing100};
    margin-right: -${layout.measurements.spacing100};
  `};
`;

export const Prompt = styled(Card)`
  background: ${p => p.theme.bg.primary};
  max-width: 500px;
  text-align: center;
`;

export const Content = styled(CardContent)`
  && {
    align-items: center;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const ScaleWrapper = styled.div`
  margin-top: 17px;
  width: 260px;

  ${media.smallOnly`
      width: 275px;
    `};
`;

export const QuestionWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${layout.measurements.spacing100};

  > h4 {
    flex-grow: 0;
    text-align: center;
  }
`;

export const Question = styled.div<{ $fade?: boolean }>`
  ${p =>
    p.$fade
      ? css`
          animation: ${fadeOut} 250ms ease-in-out 1;
        `
      : css`
          animation: ${fadeIn} 150ms ease-in-out 1;
        `}
  animation-fill-mode: forwards;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  h4 {
    display: inline;
    flex-grow: 0;
    text-align: center;

    &:first-of-type {
      margin-right: 6px;
    }

    ${media.smallOnly`
      margin-right: 0;
      margin-bottom: 0;
      display: block;
    `};
  }
`;

export const SurveyLink = styled.a`
  color: ${p => p.theme.text.callToAction};
`;

export const Close = styled.div`
  cursor: pointer;
  position: absolute;
  top: ${layout.measurements.spacing100};
  right: ${layout.measurements.spacing100};
`;

export const SubmitButton = styled(PrimaryButton)`
  max-width: max-content;
  margin-left: auto;
`;

export const Modal = styled(ModalComponent)`
  && {
    padding: ${layout.measurements.spacing150};

    ${media.smallOnly`
      width: 100vw;
      max-width: 100vw;
      bottom: 0;
      margin: 0;
    `};
  }
`;

export const ThankYouWrapper = styled.div`
  text-align: center;
  margin-top: ${layout.measurements.spacing300};
`;

export const FeedbackPrompt = styled.button`
  cursor: pointer;
  color: ${p => p.theme.text.callToAction};
`;
